/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useRef} from 'react'
import {Link} from 'react-router-dom'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useTranslation} from 'react-i18next'
import {getSalesAreaLetter, getSectorAll} from '../../../../api/modules/getdatalist'
import {createNew} from '../../../../api/modules/configuration/signing'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {Col, Row, Spinner} from 'react-bootstrap'
import {PageTitle} from '../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {getFilterCityMasterData, getRegionAllMasterData} from 'src/api/modules/master-data/master_2'
import {MultiSelect} from 'react-multi-select-component'
import {getMaterialGroup} from 'src/api/modules/master-data/master'
import Checkbox from '../../access/Checkbox'
import i18next from 'i18next'

const FormAdd: React.FC = ({}) => {
  const intl = useIntl()
  const {t} = useTranslation()

  const [fullSales, setFullSales] = useState<any[]>([])
  const [material, setMaterial] = useState([])
  const [fullSektor, setFullSektor] = useState([])

  const [sales, setSales] = useState([])
  const [module, setModule] = useState('SIP')
  const [productType, setProductType] = useState([])
  const [sektor, setSektor] = useState([])
  const [tonnageLimitActive, setTonnageLimitActive] = useState(false)
  const [tonnageLimitFrom, setTonnageLimitFrom] = useState(0)
  const [tonnageLimitTo, setTonnageLimitTo] = useState(0)
  const [signerName, setSignerName] = useState('')
  const [signerPosition, setSignerPosition] = useState('')
  const [regions, setRegions] = useState<any[]>([])
  const [cities, setCities] = useState<any>([])
  const [regionCode, setRegionCode] = useState<any>([])
  const [cityCode, setCityCode] = useState<any[]>([])
  const [regionCreate, setRegionCreate] = useState<any>('')
  const [status, setStatus] = useState(true)

  const navigate = useNavigate()

  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    const getSales = async () => {
      await getSalesAreaLetter().then((res) => {
        setFullSales(res.data.data)
      })
    }
    const getRegion = async () => {
      const res = await getRegionAllMasterData()
      const data = res.data.data
      setRegions(data)
    }
    const getMaterial = async () => {
      const res = await getMaterialGroup()
      setMaterial(res.data.data)
    }
    const getSector = async () => {
      const res = await getSectorAll()
      setFullSektor(res.data.data)
    }

    getRegion()
    getSales()
    getMaterial()
    getSector()
  }, [])

  const handleRegion = async (e: any) => {
    setRegionCode([...e])
    let arr: any = []
    const selectedRegion = [...e].map((item: any) => item.value)
    let getRegionValue = selectedRegion.join(',')
    arr.push(selectedRegion)

    setRegionCreate(arr[0])
    await getFilterCityMasterData(getRegionValue).then((res: any) => {
      const data = res.data.data
      setCities(data)
    })
  }

  const handleClickTonnageLimitActive = (e: any) => {
    setTonnageLimitActive(e.target.checked)
  }

  const handleClickStatus = (e: any) => {
    setStatus(e.target.checked)
  }

  const handleSubmit = async () => {
    setBtnLoading(true)

    await createNew({
      module,
      sector_ids: sektor.map((item: any) => item.value),
      sales_org_codes: sales.map((item: any) => item.value),
      product_types: productType.map((item: any) => item.value),
      province_ids: regionCode.map((item: any) => item.value),
      city_ids: cityCode.map((item: any) => item.value),
      quantum_limition: tonnageLimitActive ? 1 : 0,
      quantum1: tonnageLimitActive ? tonnageLimitFrom : undefined,
      quantum2: tonnageLimitActive ? tonnageLimitTo : undefined,
      signer_name: signerName,
      signer_position: signerPosition,
      is_active: status ? 1 : 0,
      lang: i18next.language,
      credentials: localStorage.getItem('credential'),
    })
      .then(() => {
        swal({
          title: `${t('configuration signing submited')}`,
          icon: 'success',
        }).then(() => navigate('/configuration/signing'))
      })
      .catch((error) => {
        swal({
          closeOnClickOutside: false,
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>• {t('Add Configuration Signing')}</PageTitle>
      <div className={`card`}>
        <div className='card-body '>
          <Row className='mb-4'>
            <Col md={6}>
              <Form.Group className='mb-5' controlId='formBasicPassword'>
                <Form.Label>{t('Module')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  onChange={(e: any) => setModule(e.target.value)}
                >
                  <option value='SIP'>SIP</option>
                  <option value='SKPP'>SKPP</option>
                  <option value='SO'>SO</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col sm={6}>
              <Form.Label>{t('Sector')}</Form.Label>
              <MultiSelect
                options={fullSektor?.map((item: any) => {
                  return {label: t(item.name), value: item.id}
                })}
                value={sektor}
                onChange={setSektor}
                labelledBy='Select'
              />
            </Col>

            {module != 'SIP' && <Col md={6}>
                  <Form.Group className='mb-5' controlId='formBasicPassword'>
                    <Form.Label>Sales Org</Form.Label>
                    <MultiSelect
                      options={fullSales?.map((item: any) => {
                        return {label: t(item.name), value: item.code}
                      })}
                      value={sales}
                      onChange={setSales}
                      labelledBy='Select'
                    />
                  </Form.Group>
                </Col>
              }

                <Col md={6}>
                  <Form.Group className='mb-5'>
                    <Form.Label>{t('Product-Type')}</Form.Label>
                    <MultiSelect
                      options={material?.map((item: any) => {
                        return {
                          label: t(item.material_group_desc),
                          value: item.material_group,
                        }
                      })}
                      value={productType}
                      onChange={setProductType}
                      labelledBy='Select'
                    />
                  </Form.Group>
                </Col>

                {module != 'SIP' && (
                  <>
                <Col md={6}>
                  <Form.Group className='mb-5'>
                    <Form.Label>{t('sub-order-provinsi')}</Form.Label>
                    <MultiSelect
                      options={regions.map((item: any) => {
                        return {
                          value: item.id,
                          label: item.value,
                        }
                      })}
                      value={regionCode}
                      onChange={handleRegion}
                      labelledBy='Select'
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className='mb-5'>
                    <Form.Label>{t('sub-order-kota')}</Form.Label>
                    <MultiSelect
                      options={cities?.map((item: any) => {
                        return {label: item.value, value: item.id}
                      })}
                      value={cityCode}
                      onChange={setCityCode}
                      labelledBy='Select'
                    />
                  </Form.Group>
                </Col>
              </>
            )}

            <Col md={12}>
              <Form.Group className='mb-5'>
                <Checkbox
                  id='checkbox-tonnage-limit-active'
                  type='checkbox'
                  name='tonnage-limit'
                  handleClick={handleClickTonnageLimitActive}
                  isChecked={tonnageLimitActive}
                />
                <Form.Label className='ms-3'>{t('Batasan Tonase')}</Form.Label>
              </Form.Group>
            </Col>

            {tonnageLimitActive && (
              <>
                <Col md={6}>
                  <Form.Group className='mb-5'>
                    <Form.Label>{t('Minimal') + ' ' + t('sub-order-kuantum')}</Form.Label>
                    <Form.Control
                      id='quantum_1'
                      type='number'
                      min='0'
                      placeholder={t('Minimal') + ' ' + t('sub-order-kuantum')}
                      value={tonnageLimitFrom}
                      onChange={(e: any) => setTonnageLimitFrom(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className='mb-5'>
                    <Form.Label>{t('Maksimal') + ' ' + t('sub-order-kuantum')}</Form.Label>
                    <Form.Control
                      id='quantum_2'
                      type='number'
                      min='0'
                      placeholder={t('Maksimal') + ' ' + t('sub-order-kuantum')}
                      value={tonnageLimitTo}
                      onChange={(e: any) => setTonnageLimitTo(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </>
            )}

            <Col md={6}>
              <Form.Group className='mb-5'>
                <Form.Label>{t('Assigner Name')}</Form.Label>
                <Form.Control
                  id='signer_name'
                  type='text'
                  placeholder={t('Assigner Name')}
                  value={signerName}
                  onChange={(e: any) => setSignerName(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className='mb-5'>
                <Form.Label>{t('Assigner Position')}</Form.Label>
                <Form.Control
                  id='signer_position'
                  type='text'
                  placeholder={t('Assigner Position')}
                  value={signerPosition}
                  onChange={(e: any) => setSignerPosition(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className='mb-5'>
                <Checkbox
                  id='checkbox-status'
                  type='checkbox'
                  name='status'
                  handleClick={handleClickStatus}
                  isChecked={status}
                />
                <Form.Label className='ms-3'>{t('activate')}</Form.Label>
              </Form.Group>
            </Col>
          </Row>
        </div>

        <div className='d-flex justify-content-end p-8'>
          <Link to={'/configuration/signing'}>
            <Button className='btn btn-secondary me-2'>{t('berita-batal')}</Button>
          </Link>
          <Button className='btn btn-primary' onClick={() => handleSubmit()} disabled={btnLoading}>
            {btnLoading ? (
              <Spinner animation='border' variant='light' size='sm' />
            ) : (
              t('order-kirim')
            )}
          </Button>
        </div>
      </div>
    </>
  )
}

export {FormAdd}
